// Browser polyfills
import 'whatwg-fetch';

// Libs
import React, { Fragment, useState, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

// Bridge
import { Bridge } from '@nackle/bridge';
import auth from './app-auth.js';

// Routing
import { Route, routeHistory, Link } from '@nackle/biw-web-router';
import { routes, getMiddleware as getRouteMiddleware } from './app-routing.jsx';

import { Layout, Menu } from 'antd';

// Components
import AppHeader from './components/app-header/header.jsx';

// Styles
import './styles/app.less';


/*******************************************************************************
 *  1. App (root level component)
 */

const App = () => {
    const { Header, Footer } = Layout;
    const [ user, setUser ] = useState( {} );

    const handleSignIn = async ( user ) => {
        setUser( user );
    };

    return (
        <Layout className='app-root'>

            <AppHeader />

            <Bridge
                autoSignIn={ true }
                auth={ auth }
                requiresAuth={ true }
                onSignIn={ handleSignIn }
                onRefresh={ handleSignIn } >

                <Header>
                    <div className="logo" />
                    <Menu theme="dark" mode="horizontal" defaultSelectedKeys={ [ '1' ] }>
                        <Menu.Item key="1">
                            <Link to="/home">Home</Link>
                        </Menu.Item>
                        <Menu.Item key="2">
                            <Link to="/about">About</Link>
                        </Menu.Item>
                    </Menu>
                </Header>

                <Suspense fallback={ <div>Loading...</div> }>
                    <Route render={ ( route ) => {
                        document.title = route && route.match ? route.match.title : 'Some default page title';

                        return route.match &&
                            <Fragment>
                                { React.cloneElement( route.component, {
                                    className: getRouteClassName( route.pathname, 'view' ),
                                    auth: user,
                                    locale: 'en-US'
                                } ) }
                            </Fragment>;
                    } } />
                </Suspense>

            </Bridge>

            <Footer style={ { textAlign: 'center' } }>© { new Date().getFullYear() } BI WORLDWIDE™ All Rights Reserved.</Footer>

        </Layout>
    );

};

const getRouteClassName = ( pathname, prefix ) => {
    const classList = [ prefix ];

    // let prefix = '--';
    prefix = `${ prefix }-`;
    pathname.substring( 1 ).split( '/' ).forEach( ( part ) => {
        classList.push( `${ prefix }${ part }` );
        prefix = `${ prefix }${ part }-`;
    } );

    return classList.join( ' ' );
};

/*******************************************************************************
 *  2. Connect Routing
 */
routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( getRouteMiddleware( /* AppStore */ ) );


/*******************************************************************************
 * 3. Render
 */

const container = document.getElementById( 'app-root' );
const root = createRoot( container );
root.render( <App /> );
